import { atom } from 'jotai'

export const customerAdminAtoms = atom({ china: [] as string[], oversea: [] as string[] })
export const financialOperatorAtoms = atom({ china: [] as string[], oversea: [] as string[] })
